import { Outlet, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import HeroSection from "../HeroSection";

// Helper function to extract query parameters
const getQueryParam = (search, param) => {
  const params = new URLSearchParams(search);
  return params.get(param);
};

export default function Layout() {
  const [userData, setUserData] = useState(null);
  const formRef = useRef(null);
  const location = useLocation();
  const search = location.search;

  // Extract patientId and mobile from query params
  const patientId = getQueryParam(search, "patientID");
  const mobile = getQueryParam(search, "mobileNumber");

  useEffect(() => {
    // Handle patientId & mobile parameters
    if (patientId && mobile) {
      setUserData({
        patientId: decodeURIComponent(patientId),
        mobile: decodeURIComponent(mobile)
      });
      localStorage.setItem(
        "selectedIndex",
        JSON.stringify({ _id: patientId, phone_number: mobile })
      );
    }
  }, [patientId, mobile]);

  console.log(location, "location");
  return (
    <>
      {!search.startsWith("?patientID=") && <Header />}
      {!search.startsWith("?patientID=") ? (
        // <Banner formRef={formRef} />
        <HeroSection />
      ) : null}
      <main>
        <Outlet context={{ formRef, userData }} />
      </main>
      {!search.startsWith("?patientID=") && <Footer />}
    </>
  );
}
